import React from "react";
import {Col, Divider, Layout} from "antd";
import {useRecoilValue} from "recoil";
import {globalBrandModuleSettingState} from "../../../_common/global_state";
import {useNavigate} from "react-router-dom";
import useShared from "../../../_common/_shared";
import FooterTime from "../component/latestTime/footerTime";
import {useTranslation} from "react-i18next";
import {useIsMobile} from "../../../_common/function";

const {Footer} = Layout;

export const Footer_6 = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isMobile = useIsMobile()
    const {IconCommon} = useShared();

    const brandModuleSetting = useRecoilValue(globalBrandModuleSettingState);

    return (
        <Footer id={"layout-footer"}>
            <div className={isMobile ? "flex *:px-3 justify-center sm:justify-end p-2" : "flex *:px-3 p-2"}>
                <Col className={"text-center flex items-center !w-full flex-none justify-center sm:justify-end"}>
                    {brandModuleSetting?.find((item) => item?.isEnabled === true && item?.name === "Deposit") && (
                        <>
                            <div
                                className={"flex items-center justify-center cursor-pointer"}
                                onClick={() => navigate("/wallet-deposit")}
                            >
                                <IconCommon
                                    className={"footerIcon"}
                                    iconName={"md-deposit"}
                                />
                                {!isMobile && (
                                    <span className={"footerText"}>{t("module.deposit")}</span>
                                )}
                            </div>
                            <Divider type={"vertical"} className={"footerDivider"}/>
                        </>
                    )}
                    {brandModuleSetting?.find((item) => item?.isEnabled === true && item?.name === "Withdrawal") && (
                        <>
                            <div
                                className={"flex items-center justify-center cursor-pointer"}
                                onClick={() => navigate("/wallet-withdrawal")}
                            >
                                <IconCommon className={"footerIcon"} iconName={"md-withdrawal"}/>
                                {!isMobile && (
                                    <span className={"footerText"}>{t("module.withdrawal")}</span>
                                )}
                            </div>
                            <Divider type={"vertical"} className={"footerDivider"}/>
                        </>
                    )}
                    {brandModuleSetting?.find((item) => item?.isEnabled === true && item?.name === "Support") && (
                        <>
                            <div className={"flex items-center justify-center cursor-pointer"}>
                                <IconCommon className={"footerIcon"} iconName={"md-support"}/>
                                {!isMobile && (
                                    <span className={"footerText"}>{t("module.support")}</span>
                                )}
                            </div>
                            <Divider type={"vertical"} className={"footerDivider"}/>
                        </>
                    )}
                    <div className={"flex items-center justify-center"}>
                        <FooterTime/>
                    </div>
                </Col>
            </div>
        </Footer>
    );
};
